<template>
  <div class="mt-3">
    <div class="box" v-if="ContainerList.length > 0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped table-sm">
          <thead class="thead-dark">
            <tr>
              <th width="40">
                <input
                  ref="selectAllCheckbox"
                  type="checkbox"
                  v-model="selectAll"
                  @change="toggleSelectAll"
                />
              </th>
              <th>Container No.</th>
              <th>Container Type</th>
              <th>Custom Seal No</th>
              <th>Line Seal No</th>
              <th>Measurement</th>
              <th>Gross Weight</th>
              <th>Package Details</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in ContainerList" :key="index">
              <td>
                <input
                  type="checkbox"
                  v-model="item.selected"
                  @change="updateSelectAll"
                />
              </td>
              <td>{{ item.containerNo }}</td>
              <td>{{ item.containerType }}</td>
              <td>{{ item.customSealNo }}</td>
              <td>{{ item.LineSealNo }}</td>
              <td>{{ item.measurement }}</td>
              <td>{{ item.grossWeight }} {{ item.weightUnit }}</td>
              <td>{{ item.noOfpkgUnit }} {{ item.packageName }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <b-row class="mt-3">
        <b-col cols="12">
          <b-alert variant="info" show>
            <strong>Container Selection:</strong> Use the checkboxes to select
            individual containers or bulk select below. Containers with split
            status are disabled.
          </b-alert>
        </b-col>

        <b-col cols="12" v-if="!hasSelected">
          <b-alert variant="warning" show>
            <strong>Warning:</strong> Please select at least one container to
            proceed.
          </b-alert>
        </b-col>
      </b-row>

      <b-row class="align-items-center mt-2">
        <b-col cols="12" md="6" class="mb-2 mb-md-0">
          <b-button
            size="sm"
            variant="info"
            class="mr-2"
            @click="selectAllContainers"
          >
            Select All
          </b-button>
          <b-button
            size="sm"
            variant="secondary"
            @click="deselectAllContainers"
          >
            Deselect All
          </b-button>
        </b-col>

        <b-col cols="12" md="6" class="text-md-right text-muted small">
          Selected:
          <strong>{{ selectedCount }}</strong> /
          {{ selectableCount }} containers
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import CommonService from '../../services/CommonService';

export default {
  name: "ContainerTable",
  props: {
    PMC_JOBID: {
      type: Number,
      default: 0,
    },
    containers: {
      type: Array,
      required: true,
    },
    showContainerStatus: {
      type: Boolean,
      default: false,
    },
  },
  beforeMount() {
    if (this.PMC_JOBID && this.PMC_JOBID > 0) {
      this.getContainer("Normal");
    } else {
      this.initContainerListFromProp();
    }
  },
  data() {
    return {
      selectAll: false,
      isLoading: false,
      ContainerList: [],
    };
  },
  computed: {
    hasSelected() {
      return this.ContainerList.some((c) => c.selected);
    },
    selectedCount() {
      return this.ContainerList.filter((c) => c.selected).length;
    },
    selectableCount() {
      return this.ContainerList.filter((c) => c.containerWithSplit !== 1).length;
    },
    isIndeterminate() {
      const selected = this.selectedCount;
      const total = this.selectableCount;
      return selected > 0 && selected < total;
    },
  },
  watch: {
    containers: {
      handler(newVal) {
        this.initContainerListFromProp();
      },
      deep: true,
      immediate: true,
    },
  },
  updated() {
    if (this.$refs.selectAllCheckbox) {
      this.$refs.selectAllCheckbox.indeterminate = this.isIndeterminate;
    }
  },
  methods: {
    initContainerListFromProp() {
      const list = Array.isArray(this.containers) ? this.containers : [];
     
        if(list.length>0){
            this.ContainerList = list.map(item =>
                Object.assign({}, item, {
                    selected: item.selected === true,
                    containerWithSplit: item.containerWithSplit || 0
                })
            );
        }
      this.selectAll = this.selectableCount > 0 && this.selectedCount === this.selectableCount;
    },

    toggleSelectAll() {
      this.ContainerList.forEach((item) => {
        if (item.uniqueContainerId) {
          item.selected = this.selectAll;
        }
      });
       this.emitSelection();
    },

    updateSelectAll() {
      const total = this.selectableCount;
      const selected = this.selectedCount;
    //   this.selectAll = total === selected;
    this.selectAll = total > 0 && total === selected;
      this.emitSelection();
    },

    selectAllContainers() {
      this.selectAll = true;
      this.toggleSelectAll();
    },
    deselectAllContainers() {
      this.selectAll = false;
      this.toggleSelectAll();
      this.$emit("status-change", { item: null, index: null, type: "deselect-all" });
    },
    onStatusChange(item, index) {
      this.$emit("status-change", { item, index });
    },
     emitSelection() {
      const selectedItems = this.ContainerList.filter((i) => i.selected);
      this.$emit("status-change", selectedItems);
    },

    getContainer(type) {
      this.ContainerList = [];
      let payload = {};
      if (this.PMC_JOBID) {
        if (type == "Normal") {
          this.isLoading = true;
        }
        payload = {
          itemCode: "getJobContainerDetails",
          allModuleId: this.PMC_JOBID,
          type: type,
        };

        CommonService.getAllJobList(payload)
          .then((response) => {
            const { data } = response;
            const list = data.ContainerList || [];

            if (list.length > 0) {
              this.ContainerList = list.map(item =>
                Object.assign({}, item, { selected: false, })
              );
            } else {
              this.ContainerList = [];
            }
            this.selectAll = this.selectableCount > 0 && this.selectedCount === this.selectableCount;

            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on ContainerList Error: ", error);
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
  text-align: center;
}
.box {
  border: 1px solid #ddd;
  padding: 1rem;
  border-radius: 8px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// ContainerTable.vue?2654a3c8